/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InvestmentStyleDiagnosisInterestScore model module.
 * @module model/InvestmentStyleDiagnosisInterestScore
 * @version 1.0.0
 */
class InvestmentStyleDiagnosisInterestScore {
    /**
     * Constructs a new <code>InvestmentStyleDiagnosisInterestScore</code>.
     * @alias module:model/InvestmentStyleDiagnosisInterestScore
     */
    constructor() { 
        
        InvestmentStyleDiagnosisInterestScore.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InvestmentStyleDiagnosisInterestScore</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InvestmentStyleDiagnosisInterestScore} obj Optional instance to populate.
     * @return {module:model/InvestmentStyleDiagnosisInterestScore} The populated <code>InvestmentStyleDiagnosisInterestScore</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InvestmentStyleDiagnosisInterestScore();

            if (data.hasOwnProperty('key')) {
                obj['key'] = ApiClient.convertToType(data['key'], 'String');
            }
            if (data.hasOwnProperty('score')) {
                obj['score'] = ApiClient.convertToType(data['score'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>InvestmentStyleDiagnosisInterestScore</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>InvestmentStyleDiagnosisInterestScore</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['key'] && !(typeof data['key'] === 'string' || data['key'] instanceof String)) {
            throw new Error("Expected the field `key` to be a primitive type in the JSON string but got " + data['key']);
        }

        return true;
    }


}



/**
 * 関心グラフの項目キー
 * @member {module:model/InvestmentStyleDiagnosisInterestScore.KeyEnum} key
 */
InvestmentStyleDiagnosisInterestScore.prototype['key'] = undefined;

/**
 * @member {Number} score
 */
InvestmentStyleDiagnosisInterestScore.prototype['score'] = undefined;





/**
 * Allowed values for the <code>key</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisInterestScore['KeyEnum'] = {

    /**
     * value: "stable_income"
     * @const
     */
    "stable_income": "stable_income",

    /**
     * value: "long_term_asset"
     * @const
     */
    "long_term_asset": "long_term_asset",

    /**
     * value: "low_effort"
     * @const
     */
    "low_effort": "low_effort",

    /**
     * value: "high_yield"
     * @const
     */
    "high_yield": "high_yield",

    /**
     * value: "short_term_gain"
     * @const
     */
    "short_term_gain": "short_term_gain",

    /**
     * value: "tax_saving"
     * @const
     */
    "tax_saving": "tax_saving",

    /**
     * value: "loss_avoidance_safety"
     * @const
     */
    "loss_avoidance_safety": "loss_avoidance_safety",

    /**
     * value: "loss_avoidance_low_initial"
     * @const
     */
    "loss_avoidance_low_initial": "loss_avoidance_low_initial",

    /**
     * value: "loss_avoidance_trusted"
     * @const
     */
    "loss_avoidance_trusted": "loss_avoidance_trusted"
};



export default InvestmentStyleDiagnosisInterestScore;

